import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import { formatPriceDecimals } from 'utils/format'

import styles from './grid-cell-deal.css'

const GridCellDeal = ({
  deal,
  sellableItem,
  canRemove,
  onRemove,
  isOnsale,
  isPriceDifferent,
  discountPrice,
  initialPrice,
  bookingFee,
  showInitialPrice,
}) => (
  <div styleName="container" style={{ color: sellableItem.color, opacity: (isOnsale ? 1 : 0.6) }}>
    <div styleName="title-container">
      <div styleName="name" title={sellableItem.name}>
        {sellableItem.name}
        {!isOnsale && <span styleName="offsale"> [Off Sale]</span>}
      </div>
      {canRemove && <div styleName="remove" onClick={onRemove}>x</div>}
    </div>
    <div styleName="details">
      <div styleName="prices">
        <span>{formatPriceDecimals(discountPrice, 'GBP')}{isPriceDifferent && <span>*</span>}</span>
        {showInitialPrice && <span styleName="initial-price">{formatPriceDecimals(initialPrice, 'GBP')}</span>}
        {bookingFee && <span styleName="booking-fee">+ {formatPriceDecimals(bookingFee, 'GBP')}</span>}
      </div>
      {deal.ticketCount && <div styleName="tickets">{deal.soldTickets}/{deal.ticketCount}</div>}
    </div>
  </div>
)

GridCellDeal.propTypes = {
  deal: PropTypes.object.isRequired,
  canRemove: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired,
  sellableItem: PropTypes.object.isRequired,
  isOnsale: PropTypes.bool.isRequired,
  isPriceDifferent: PropTypes.bool.isRequired,
  discountPrice: PropTypes.object.isRequired,
  initialPrice: PropTypes.object.isRequired,
  bookingFee: PropTypes.object,
  showInitialPrice: PropTypes.bool.isRequired,
}

export default CSSModules(GridCellDeal, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-cell-deal/grid-cell-deal.js
 **/